import { Button, Drawer, theme } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useSubscribeEffect } from "src/hooks/useSubscribeEffect";
import { SearchContext, useSearch } from "../useSearchContext";
import { serializeParams } from "../lib/params-state-reducer";
import { SearchActions } from "../types";
import { SubQueryDashboard } from "./SubQueryDashboard";
import { ActivityFeed } from "src/components/ActivityFeed";
import { CssVars } from "src/components/CssVars";

export function SubQueryPreview({
  context,
  config,
}: {
  context: SearchContext;
  config?: Partial<{
    openInExplore: boolean;
  }>;
}) {
  const { token } = theme.useToken();
  const { subquery, entity, params } = context;
  const key = serializeParams(subquery.state);
  return (
    <Drawer
      zIndex={200}
      mask={!Boolean(entity.uuid)}
      key={key}
      open={Boolean(subquery.state)}
      onClose={subquery.close}
      width={"80%"}
      style={{ minWidth: "400px" }}
      bodyStyle={{
        width: "100%",
        height: "100%",
        overflow: "hidden",
        padding: 0,
        position: "relative",
      }}
      extra={
        <div>
          {config?.openInExplore !== false && (
            <Button
              type="primary"
              className="action-button"
              style={{
                backgroundColor: token.colorPrimary,
                borderColor: token.colorPrimary,
              }}
              onClick={() => {
                params.dispatch({
                  type: SearchActions.loadState,
                  value: serializeParams(subquery.state),
                });
                subquery.close();
              }}
            >
              <ArrowLeftOutlined />
              Open in Explore
            </Button>
          )}
        </div>
      }
    >
      <SubQueryDashboard context={context} />
    </Drawer>
  );
}

export function SubQueryPreviewProvider({
  context,
}: {
  context: SearchContext;
}) {
  const search = useSearch(context.subquery.state);
  return <SubQueryEventList context={{ ...search, entity: context.entity }} />;
}

function SubQueryEventList({ context }: { context: SearchContext }) {
  const { eventsList, entitiesList, params } = context;
  useSubscribeEffect(eventsList);
  useSubscribeEffect(entitiesList);
  const usingEvents = !params.selectors.hasSelects(params.state);
  const data = usingEvents
    ? eventsList.data?.data || []
    : entitiesList.data?.data || [];
  const loading = usingEvents ? eventsList.isLoading : entitiesList.isLoading;

  return (
    <div className="drawer-panel">
      <ActivityFeed
        data={{
          data,
          meta: usingEvents ? eventsList.data?.meta : entitiesList.data?.meta,
        }}
        isLoading={loading}
        setPagination={(pagination) => {
          if (usingEvents) {
            eventsList.setPagination(pagination);
          } else {
            entitiesList.setPagination(pagination);
          }
        }}
      />
    </div>
  );
}
